// import drawTable from './drawTable';

import mapInteractions from '../utils/mapInteractions';

export default function (map, data) {
  map.addSource('snow-polygons', {
    // GeoJSON Data source used in vector tiles, documented at
    // https://gist.github.com/ryanbaumann/a7d970386ce59d11c16278b90dde094d
    type: 'geojson',
    data,
  });
  map.addLayer({
    id: 'snow-polygon-layer',
    type: 'fill-extrusion',
    source: 'snow-polygons',
    paint: {
    // See the Mapbox Style Specification for details on data expressions.
    // https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions
    // Get the fill-extrusion-color from the source 'color' property.
      // 'fill-extrusion-color': 'red',
      'fill-extrusion-color': [
        'let',
        'level',
        ['get', 'snow'],
        ['interpolate', ['linear'], ['var', 'level'],
          0, ['to-color', '#f7f4f9'],
          4, ['to-color', '#e7e1ef'],
          8, ['to-color', '#d4b9da'],
          12, ['to-color', '#c994c7'],
          16, ['to-color', '#df65b0'],
          20, ['to-color', '#e7298a'],
          24, ['to-color', '#ce1256'],
        ],
      ],
      // Get fill-extrusion-height from the source 'height' property.
      'fill-extrusion-height': ['get', 'snow_weighted'],
      // Get fill-extrusion-base from the source 'base_height' property.
      // Make extrusions slightly opaque for see through indoor walls.
      'fill-extrusion-opacity': 0.9,
    },
  });

  // add click event to display popups when feature is clicked
  map.on('click', (event) => mapInteractions.displayPopup(map, event));

  // changes cursor to pointer when mousing over a feature
  map.on('mousemove', (event) => mapInteractions.updateMapCursor(map, event));
}
